import "./Vendor";
import "react-block-ui/style.css";
import "loaders.css/loaders.min.css";
import "./Styles/Site.scss";
import "react-app-polyfill/ie9";
import "react-app-polyfill/stable";
import React from "react";
import ReactDOM from "react-dom";
import detectBrowserLanguage from "detect-browser-language";
import translationsObject from "./Resources/Resources";
import { Provider } from "react-redux";
import { loadTranslations, setLocale, syncTranslationWithStore } from "react-redux-i18n";
// import { AppContainer } from "react-hot-loader";
// import { BrowserRouter } from "react-router-dom";
// import RoutesModule from "./Routes";
// let routes = RoutesModule.routes;
import Constants from "./AppConstants/Constants";
import Router from "./Router";
import configureStore from "./Store/ConfigureStore";

const userLanguage = detectBrowserLanguage();

syncTranslationWithStore(configureStore);
configureStore.dispatch(loadTranslations(translationsObject));
configureStore.dispatch(setLocale(Constants.DEFAULT_LANGUAGE.code));

// function renderApp() {
//     // This code starts up the React app when it runs in a browser. It sets up the routing
//     // configuration and injects the app into a DOM element.
//     //const baseUrl = document.getElementsByTagName("base")[0] ? document.getElementsByTagName("base")[0].getAttribute("href") : "";
//     ReactDOM.render(
//         <AppContainer>
//             <BrowserRouter children={routes} basename="/" />
//         </AppContainer>,
//         document.getElementById("react-app")
//     );
// }

function renderApp() {
    ReactDOM.render(
        <Provider store={configureStore}>
            <Router/>
        </Provider>,
        document.getElementById("react-app")
    );
}

renderApp();

// Allow Hot Module Replacement
// if (module.hot) {
//     module.hot.accept("./routes", () => {
//         routes = require("./routes").routes;
//         renderApp();
//     });
// }